import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

// eslint-disable-next-line import/no-cycle
import { useTranslation } from 'react-i18next';

import MainFont from 'ui/typography/mainFont';

// eslint-disable-next-line import/no-cycle
import { TabEL, TabItem, TabsContainer } from './style';

const Tabs = ({ tabs, onChange, tabType, selected, color }) => {
  const [selectedTab, setSelectedTab] = useState(selected);

  useEffect(() => {
    setSelectedTab(selected);
  }, [selected]);

  const handleOnclickTab = tab => {
    setSelectedTab(tab);
    if (onChange) onChange(tab);
  };

  const { t } = useTranslation();

  return (
    <TabsContainer tabType={tabType} color={color}>
      {tabs.map(tab => (
        <TabItem
          onClick={() => handleOnclickTab(tab)}
          key={tab.value}
          className={tab?.label === selectedTab?.label ? 'active' : ''}
          color={color}
        >
          <TabEL type={tab?.label === selectedTab?.label ? 'activeTab' : 'tab'}>
            <MainFont>{t(tab?.value)}</MainFont>
          </TabEL>
        </TabItem>
      ))}
    </TabsContainer>
  );
};

Tabs.TYPE = {
  PRIMARY: 'primary',
  DRAFT: 'draft'
};

Tabs.defaultProps = {
  tabType: Tabs.TYPE.PRIMARY
};

Tabs.propTypes = {
  tabs: PropTypes.array.isRequired,
  tabType: PropTypes.string,
  selected: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  color: PropTypes.string
};

export default Tabs;
